import { createContext } from 'react';
import { DomainList } from 'common/constants/domain';

export const DomainContext = createContext(Object.values(DomainList)[0]);
